import { FC } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import Button from "react-bootstrap/esm/Button";
import Alert from "react-bootstrap/esm/Alert";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { reportRoute, reportVersionDailyTestCompletionEmailSendRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { useSendDailyTestCompletionEmailMutation } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";

export const SendDailyTestCompletionReportVersionEmailScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(reportVersionDailyTestCompletionEmailSendRoute);

    const [send, { data, loading, error }] = useSendDailyTestCompletionEmailMutation({
        variables: { reportVersionId: reportVersionGraphId(versionId) },
    });

    return data?.sendDailyTestCompletionEmailReportVersion != null ? (
        <Navigate to={reportRoute.build({ reportId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={reportVersionDailyTestCompletionEmailSendRoute} />

                {error ? <Alert variant="danger">{error.message}</Alert> : null}

                <Alert variant="info">Do you really want to send the daily test completion email?</Alert>

                <Button disabled={loading} onClick={() => send()}>
                    Send
                </Button>
            </Container>
        </NavigationScreen>
    );
};
